import { Reveal } from "@/components/Motion";
import { Home, HandHeart, Users } from "lucide-react";

const services = [
  {
    icon: Home,
    title: "Rental Assistance",
    body: "Direct rental support that offsets the ongoing cost of housing, giving mothers a stable home base while they navigate a lengthy application and eligibility process.",
  },
  {
    icon: HandHeart,
    title: "Supportive Services",
    body: "Wraparound care, coordination, and essential family supports — helping mothers increase their independence and build the daily routines that keep children thriving.",
  },
  {
    icon: Users,
    title: "DCP&P Partnership",
    body: "In coordination with the Division of Child Protection and Permanency, we strengthen and stabilize vulnerable families through community-based care.",
  },
];

const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="relative py-24 md:py-32 px-6 md:px-10 max-w-[1400px] mx-auto"
  >
    <Reveal className="max-w-3xl mb-14 md:mb-20">
      <p className="text-xs uppercase tracking-[0.3em] text-[#C85A3C] mb-6">What We Do</p>
      <h2 className="font-serif-display font-light leading-[1.02] tracking-tight text-4xl md:text-6xl text-[#1A1A1A]">
        Practical support, delivered with care.
      </h2>
    </Reveal>

    <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-[#1A1A1A]/10">
      {services.map((s, i) => (
        <Reveal
          key={s.title}
          delay={i * 0.1}
          className="group border-b border-r border-[#1A1A1A]/10 p-8 md:p-12 hover:bg-white transition-colors duration-500"
          data-testid={`service-card-${i}`}
        >
          <s.icon
            size={34}
            strokeWidth={1.4}
            className="text-[#C85A3C] mb-8 transition-transform duration-500 group-hover:-translate-y-1"
          />
          <h3 className="font-serif-display text-3xl font-light tracking-tight text-[#1A1A1A] mb-4">
            {s.title}
          </h3>
          <p className="text-base leading-relaxed text-[#1A1A1A]/70">{s.body}</p>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Services;
